export default function ChatgptIntro() {
  return <h2>Chatgpt Intro</h2>;
}
